<template>
    <resources-base-table
        :inputs="inputs"
        :headers="headers"
        :items="universidades"
        :editedItem="editedItem"
        :defaultItem="defaultItem"
        :modelService="universidadesService"
    >
        <template v-slot:middle-title>
            <v-select
                class="ml-2"
                v-model="pais"
                :items="paises"
                item-text="nombre"
                item-value="value"
                label="País"
                hide-details
            ></v-select>
        </template>
        <template v-slot:form="{ localEditedItem, afterDialogOpen }">
            <span v-for="field in inputs" :key="field.value">
                <models-universidades-field
                    :field="field"
                    :localEditedItem="localEditedItem"
                    :afterDialogOpen="afterDialogOpen"
                ></models-universidades-field>
            </span>
        </template>
        <template v-slot:actions="{ item }">
            <router-link :to="{ name: 'UniversidadSedes', params: { id: item.id } }">
                <v-icon small>sedes</v-icon>
            </router-link>
        </template>
    </resources-base-table>
</template>

<script>
import { UniversidadesService } from "../../../services/carreras-api.service"

export default {
    data: () => ({
        pais: { nombre: "Todos", value: null },
        paises: [
            { nombre: "Todos", value: null },
            { nombre: "Chile", value: "Chile" },
            { nombre: "Colombia", value: "Colombia" }
        ],
        universidadesService: UniversidadesService,
        inputs: [
            {
                sortable: true,
                text: "Universidad",
                value: "universidad"
            },
            {
                text: "Logo",
                value: "logo",
                sortable: false
            },
            {
                text: "Nombre Contacto",
                value: "nombre_contacto",
                sortable: false
            },
            {
                text: "Cargo Contacto",
                value: "cargo_contacto",
                sortable: false
            },
            {
                text: "Email Contacto",
                value: "mail_contacto",
                sortable: false
            },
            {
                text: "Teléfono Contacto",
                value: "telefono_contacto",
                sortable: false
            },
            {
                text: "Presentación",
                value: "presentacion",
                sortable: false,
                type: "ckeditor"
            },
            {
                text: "Imágen anuncio ancha (desktop, tamaño máximo 2MB)",
                value: "anuncioImgWide",
                sortable: false,
                type: "file",
                uploading: false,
                errorDialog: true,
                errorDialogOpen: false,
                errorDialogTitle: "Error al subir imágen",
                errorDialogText: "No se ha podido subir la imágen adjunta. Por favor inténtelo en unos momentos."
            },
            {
                text: "Imágen anuncio angosta (mobile, tamaño máximo 2MB)",
                value: "anuncioImgNarrow",
                sortable: false,
                type: "file",
                uploading: false,
                errorDialog: true,
                errorDialogOpen: false,
                errorDialogTitle: "Error al subir imágen",
                errorDialogText: "No se ha podido subir la imágen adjunta. Por favor inténtelo en unos momentos."
            },
            {
                text: "Link anuncio",
                value: "anuncioLink",
                sortable: false
            },
            {
                text: "Caja HTML",
                value: "promo",
                sortable: false,
                type: "ckeditor"
            },
            {
                text: "Campos Extras",
                value: "universidadcampoextras",
                sortable: false,
                type: "models",
                initial: {
                    _destroy: false,
                    campoextra: {
                        campoExtra: "",
                        contenido: ""
                    }
                },
                inputs: [
                    {
                        sortable: false,
                        text: "",
                        value: "campoextra",
                        type: "model",
                        inputs: [
                            {
                                sortable: false,
                                text: "Titulo",
                                value: "campoExtra"
                            },
                            {
                                sortable: false,
                                text: "Contenido",
                                value: "contenido",
                                type: "ckeditor"
                            }
                        ]
                    }
                ]
            }
        ],
        headers: [
            {
                sortable: true,
                text: "Universidad",
                value: "universidad"
            },
            {
                text: "Logo",
                value: "logo",
                sortable: false
            },
            {
                text: "Nombre Contacto",
                value: "nombre_contacto",
                sortable: false
            },
            {
                text: "Cargo Contacto",
                value: "cargo_contacto",
                sortable: false
            },
            {
                text: "Email Contacto",
                value: "mail_contacto",
                sortable: false
            },
            {
                text: "Teléfono Contacto",
                value: "telefono_contacto",
                sortable: false
            },
            { text: "Acciones", value: "action", sortable: false }
        ],
        editedItem: {
            universidad: "",
            logo: "",
            nombre_contacto: "",
            mail_contacto: "",
            cargo_contacto: "",
            telefono_contacto: "",
            presentacion: "",
            anuncioImgWide: "",
            anuncioImgNarrow: "",
            anuncioLink: "",
            promo: "",
            universidadcampoextras: []
        },
        defaultItem: {
            universidad: "",
            logo: "",
            nombre_contacto: "",
            mail_contacto: "",
            cargo_contacto: "",
            telefono_contacto: "",
            presentacion: "",
            anuncioImgWide: "",
            anuncioImgNarrow: "",
            anuncioLink: "",
            promo: "",
            universidadcampoextras: []
        }
    }),
    props: ["universidades"],
    watch: {
        pais() {
            this.$emit("update:pais", this.pais)
        }
    }
}
</script>
